export const BENEFIT_REDEMPTION_METHODS = [
  "visual_credential",
  "promo_code",
  "qr_dynamic",
  "pin",
  "activation_link",
] as const;

export type BenefitRedemptionMethod =
  (typeof BENEFIT_REDEMPTION_METHODS)[number];

export interface BenefitMetricsTopBenefit {
  id: string;
  title: string | null;
  tenant_id: string;
  tenant_name: string | null;
  redemptions: number;
}

export interface BenefitMetricsTopPartner {
  id: string;
  name: string | null;
  tenant_id: string;
  tenant_name: string | null;
  redemptions: number;
}

export interface BenefitMetricsRedemptionsByDay {
  date: string;
  count: number;
}

export type BenefitMetricsRedemptionsByMethod = Record<
  BenefitRedemptionMethod,
  number
>;

export interface BenefitMetricsTenantBreakdown {
  tenant_id: string;
  tenant_name: string | null;
  redemptions: number;
  redemptions_by_day: BenefitMetricsRedemptionsByDay[];
  redemptions_by_method: BenefitMetricsRedemptionsByMethod;
}

export interface BenefitMetrics {
  total_active_benefits: number;
  total_redemptions: number;
  conversion_rate: number;
  top_benefits: BenefitMetricsTopBenefit[];
  top_partners: BenefitMetricsTopPartner[];
  redemptions_by_method: BenefitMetricsRedemptionsByMethod;
  redemptions_by_day: BenefitMetricsRedemptionsByDay[];
  by_tenant: BenefitMetricsTenantBreakdown[];
}

export interface BenefitMetricsParams {
  dateFrom?: string;
  dateTo?: string;
  partnerId?: string;
  tenantId?: string;
}

/** El CSV sale de los mismos filtros que la pantalla: mismo contrato que la query. */
export type BenefitMetricsExportParams = BenefitMetricsParams;

export type BenefitMetricsExportResponse =
  | { status: 204 }
  | { status: 200; blob: Blob; filename: string };
